import styled from 'styled-components';

import 'antd/lib/input/style/index.css';

export const Container = styled.div``;

export const ModalContainer = styled.div`
  div.ModalBody {
    width: 480px;
    margin-left: -24px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 30px 47px 0 45px;
    background-color: #f7f7f7;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: 0.01px;
    color: #235f6e;
    div {
      width: 90%;
      /* padding-top: 15px; */
      padding-bottom: 15px;
      margin-bottom: 15px;
      border-bottom: 0.5px solid #eaeaea;
      span {
        font-size: 13px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: 0.01px;
        text-align: left;
        color: #999999;
      }
      p {
        font-size: 16px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.19;
        letter-spacing: 0.01px;
        text-align: left;
        color: #235f6e;
      }
    }
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 10px 30px;

  h2 {
    font-size: 24px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    span.bold {
      font-weight: bold;
    }
    span.boldGreen {
      color: #74a50a;
      font-weight: bold;
    }
  }
`;

export const ModalFooter = styled.div`
  /* width: 100%; */
  width: 480px;
  padding-bottom: 30px;
  margin-bottom: -26px;
  margin-left: -24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;

export const ButtonModal = styled.button`
  width: 168.8px;
  height: 40.1px;
  border-radius: 3.5px;
  border: none;
  background-color: ${props => (props.cancel ? '#f7f7f7' : '#235f6e')};
  color: ${props => (props.cancel ? '#999999' : '#f7f7f7')};
  margin: 20px 10px 0px 10px;
`;

export const ContainerAlerta = styled.div`
  padding: 20px;
  text-align: center;

  > h2 {
    font-size: 34px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.02px;
    text-align: center;
    color: #cc0000;
  }
  > h3 {
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: 0.01px;
    text-align: center;
    color: #cc0000;
    margin: 10px 0;
  }

  > p {
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: 0.01px;
    text-align: center;
    color: #707070;
    margin: 20px 20px 30px 20px;
  }

  div.confirmInputSenha {
    max-width: 80%;
    margin: 30px auto;
    .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
      border-color: rgba(0, 0, 0, 0.16);
      border-right-width: 1px !important;
    }
    .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
      border-color: rgba(0, 0, 0, 0.16);
      border-right-width: 1px !important;
    }
    .ant-input:hover,
    .ant-input:focus {
      border-color: rgba(0, 0, 0, 0.16);
      border-right-width: 1px !important;
    }
  }

  div.confirmAction {
    max-width: 90%;
    height: 53.2px;
    padding: 0 20px;
    margin: 0 auto 30px auto;
    border-radius: 3px;
    background-color: ${props => props.confirmaReenvioCheck && '#f5d4d4'};
    border: solid 0.5px
      ${props => (props.confirmaReenvioCheck ? '#cc0000' : 'transparent')};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1.2;
    .ant-checkbox-wrapper {
      span.ant-checkbox {
        margin-right: 10px;
      }

      span {
        color: ${props => (props.confirmaReenvioCheck ? '#cc0000' : '#707070')};
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.15;
        letter-spacing: normal;
      }
      display: flex;
      flex-direction: row;
      align-items: center;
      text-align: left;
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: #cc0000;
    }
    .ant-checkbox-checked::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 1px solid #cc0000;
      border-radius: 3px;
      visibility: hidden;
      -webkit-animation: antCheckboxEffect 0.36s ease-in-out;
      animation: antCheckboxEffect 0.36s ease-in-out;
      -webkit-animation-fill-mode: backwards;
      animation-fill-mode: backwards;
      content: '';
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #cc0000;
      border-color: #cc0000;
    }
  }

  div.buttonActions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    button {
      margin-bottom: 10px;
      width: 181.5px;
      height: 40.1px;
      border-radius: 3.5px;
      background-color: #cc0000;
      border: none;

      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.13;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
    }

    > button.buttonCancel {
      margin-bottom: 0px;
      width: 181.5px;
      height: 40.1px;
      border-radius: 3.5px;
      background-color: #fff;
      border: none;

      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.13;
      letter-spacing: normal;
      text-align: center;
      color: #999999;
    }
  }
`;

export const ContainerBoxUploadReenviar = styled.div`
  > p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: center;
    color: #282828;
    margin: 10px 0 20px 0;
  }
`;
